// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"470":"04add5fc","819":"04add5fc","947":"be77114e"}[chunkId] + ".chunk.css";
};